var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sparator fixed  top-0  border-b-4 border-green-600"})}
var staticRenderFns = []

export { render, staticRenderFns }